import { CheckedState } from "@radix-ui/react-checkbox";
import { filterClasses } from "@swivl-mono/helpers";
import { Checkbox, FormFieldWidth, Select, SelectItem } from "@swivl-mono/ui";
import * as React from "react";
import TimezoneSelect, { type ITimezone } from "react-timezone-select";

import "./HoursPicker.scss";

interface Props {
  hours: any;
  onChange: any;
  timezoneName: string;
  containerClassName?: string;
}

export default class HoursPicker extends React.Component<Props> {
  hours: SelectItem[] = [{ label: "12:00 AM", value: "0:00" }];
  constructor(props) {
    super(props);
    let hourMark = 0;
    let minuteMark = 15;
    while (hourMark < 24) {
      let hourString = hourMark > 12 ? hourMark - 12 : hourMark;
      if (hourString === 0) {
        hourString = 12;
      }
      const amPm = hourMark >= 12 ? "PM" : "AM";
      const minutesString = minuteMark < 10 ? "0" + minuteMark : String(minuteMark);

      this.hours.push({ label: `${hourString}:${minutesString} ${amPm}`, value: `${hourMark}:${minutesString}` });

      minuteMark += 15;
      if (minuteMark > 45) {
        minuteMark = 0;
        hourMark++;
      }
    }
    this.timezoneUpdate = this.timezoneUpdate.bind(this);
  }
  timezoneUpdate(tz) {
    console.log("Timezone update", tz);
    this.props.onChange({ target: { name: "hours.timezone", value: tz.value } });
  }

  renderRow(name, hours, onChange) {
    const key = name.toLowerCase();
    const handleCheckboxChange = (checked: CheckedState) => {
      const syntheticEvent = {
        target: { name: `hours.${key}.open`, value: checked }
      };

      onChange(syntheticEvent);
    };

    return (
      <div key={name} className="hoursPickerRow">
        <div className="min-w-20 shrink-0">
          <Checkbox checked={hours[key].open} label={name} name={`hours.${key}.open`} onCheckedChange={handleCheckboxChange} />
        </div>
        <Select
          options={this.hours}
          selectedValues={hours[key].start ? [hours[key].start] : []}
          hideClear
          width={FormFieldWidth.RESPONSIVE_240}
          onChange={(vals) => onChange({ target: { name: `hours.${key}.start`, value: vals[0] } } as any)}
        />
        <div className="text">to</div>
        <Select
          options={this.hours}
          selectedValues={hours[key].end ? [hours[key].end] : []}
          hideClear
          width={FormFieldWidth.RESPONSIVE_240}
          onChange={(vals) => onChange({ target: { name: `hours.${key}.end`, value: vals[0] } } as any)}
        />
      </div>
    );
  }

  render() {
    const { hours, onChange, containerClassName } = this.props;

    const rows = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map((name) => this.renderRow(name, hours, onChange));

    return (
      <div className={filterClasses("HoursPicker", containerClassName)}>
        <div className="timeZone">
          <TimezoneSelect
            className="z-20"
            value={hours.timezone}
            onChange={this.timezoneUpdate}
            styles={{
              control: (baseStyles, state) => ({
                ...baseStyles,
                ":hover": {
                  borderColor: "#ff5b02",
                  borderWidth: "1px"
                },
                borderColor: state.isFocused ? "#ff5b02" : "#ccc",
                outline: state.isFocused ? "1px solid #ff5b02" : "none"
              }),
              option: (baseStyles, state) => ({
                ...baseStyles,
                ":hover": {
                  backgroundColor: !state.isSelected ? "#ffc19c" : "#ff5b02"
                },
                backgroundColor: state.isSelected ? "#ff5b02" : "white"
              })
            }}
          />

          {/* <TimezonePicker  // We removed this because it was wildly out of date.
          value={hours.timezone}
          onChange={this.timezoneUpdate}
          style={{ width: "100%" }}
          inputProps={{
            placeholder: 'Select Timezone...',
            name: this.props.timezoneName,
          }}
        /> */}
        </div>
        {rows}
      </div>
    );
  }
}
